import { render, staticRenderFns } from "./RegionEdit.vue?vue&type=template&id=5a51606f&scoped=true"
import script from "./RegionEdit.vue?vue&type=script&lang=ts"
export * from "./RegionEdit.vue?vue&type=script&lang=ts"
import style0 from "./RegionEdit.vue?vue&type=style&index=0&id=5a51606f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a51606f",
  null
  
)

export default component.exports